import React from "react";
import { useAuth } from "../auth/useAuth";
import { getOrCreateDeviceId } from "../utils/deviceId";

const STORAGE_KEY_PREFIX = "m1member.menu.collapsed";

/**
 * Speicherschlüssel des Menüzustands je Benutzer und Gerät für `useAppShellNavigationCollapsed`, spezifisch → allgemein
 * (accountId, sonst E-Mail, sonst default). Der erste Schlüssel wird geschrieben; die übrigen übernehmen ältere Werte,
 * wenn die accountId nachträglich im Profil fehlte.
 */
export function useMenuCollapsedStorageKeys(): string[] {
  const auth = useAuth();
  const accountId = (auth.info?.accountId ?? "").trim();
  const email = (auth.info?.email ?? "").trim().toLowerCase();
  const deviceId = React.useMemo(() => getOrCreateDeviceId(), []);
  return React.useMemo(() => [
    ...(accountId ? [`${STORAGE_KEY_PREFIX}.${accountId}.${deviceId}`] : []),
    ...(email ? [`${STORAGE_KEY_PREFIX}.email:${email}.${deviceId}`] : []),
    `${STORAGE_KEY_PREFIX}.default.${deviceId}`,
  ], [accountId, email, deviceId]);
}
